import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

// Layout Component
const Layout = ({ children }: any) => {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box component="main" sx={{ flex: 1, bgcolor: "grey.50" }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
